import locationData from "./location-data.json";

const CITY_ALIASES = {
  roodeport: "roodepoort",
};

/** Services whose location-data keys use /{service}--{city}. */
export const DOUBLE_DASH_SERVICE_PREFIXES = [
  "appliance-delivery",
  "bakkie-hire",
  "courier",
  "driver-jobs",
  "fridge-delivery",
  "furniture-delivery-services",
  "house-moves",
  "last-mile-delivery",
  "mattress-delivery",
  "office-removals",
  "piano-moving",
  "student-moves",
  "truck-driver-jobs",
  "van-hire",
];

/**
 * Map a visited SEO URL to the location-data.json key that holds its copy.
 * Keeps legacy single-dash links serving the same content as canonical entries.
 */
export function resolveLocationDataPath(pathname) {
  if (!pathname) return pathname;
  if (locationData[pathname]) return pathname;

  const bakkieLegacy = pathname.match(/^\/bakkie-hire-([a-z-]+)$/);
  if (bakkieLegacy) {
    const city = CITY_ALIASES[bakkieLegacy[1]] || bakkieLegacy[1];
    const candidate = `/bakkie-hire--${city}`;
    if (locationData[candidate]) return candidate;
  }

  const furnitureLegacy = pathname.match(/^\/([a-z-]+)-furniture-transport$/);
  if (furnitureLegacy) {
    const candidate = `/furniture-delivery-${furnitureLegacy[1]}`;
    if (locationData[candidate]) return candidate;
  }

  // Chips/links use /furniture-delivery--{city}; data keys use single dash.
  const furnitureDouble = pathname.match(/^\/furniture-delivery--([a-z-]+)$/);
  if (furnitureDouble) {
    const candidate = `/furniture-delivery-${furnitureDouble[1]}`;
    if (locationData[candidate]) return candidate;
  }

  // e.g. /office-removals-centurion -> /office-removals--centurion
  if (!pathname.includes("--")) {
    for (const svc of DOUBLE_DASH_SERVICE_PREFIXES) {
      const prefix = `/${svc}-`;
      if (pathname.startsWith(prefix)) {
        const city = pathname.slice(prefix.length);
        const candidate = `/${svc}--${city}`;
        if (locationData[candidate]) return candidate;
      }
    }
  }

  return pathname;
}

export function hasLocationData(pathname) {
  const dataPath = resolveLocationDataPath(pathname);
  return Boolean(locationData[dataPath]);
}
